import { Dialog, Box, Typography, IconButton } from '@mui/material';

function CookiePolicyPanel({ open, onClose, hideBackdrop = false }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      scroll="paper"
      hideBackdrop={hideBackdrop}
      sx={{
        zIndex: 10002,
        '& .MuiDialog-container': {
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        },
        '& .MuiDialog-paper': {
          margin: 0,
          width: 'min(480px, 100vw)',
          maxWidth: 'min(480px, 100vw)',
          height: '100vh',
          maxHeight: '100vh',
        },
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: '#1a1a1f',
            color: '#FFFFFF',
            borderRadius: '12px 0 0 12px',
            border: '1px solid rgba(255,255,255,0.08)',
            p: 0,
            overflow: 'hidden',
            m: 0,
            height: '100vh',
            maxHeight: '100vh',
          }
        }
      }}
    >
      <Box sx={{ backgroundColor: '#1a1a1f', display: 'flex', flexDirection: 'column', height: '100%' }}>

        {/* Header */}
        <Box sx={{ p: { xs: 2.5, sm: 3 }, pb: 1, flexShrink: 0 }}>
          <IconButton
            onClick={onClose}
            sx={{ color: '#FFFFFF', p: 0, mb: { xs: 1, sm: 1.5 }, '&:hover': { backgroundColor: 'transparent', opacity: 0.7 } }}
          >
            <Box component="span" sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' }, lineHeight: 1, fontWeight: 300 }}>←</Box>
          </IconButton>
          <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: { xs: '1.2rem', sm: '1.35rem' }, color: '#FFFFFF' }}>
            Cookie Policy &amp; Framework
          </Typography>
        </Box>

        {/* Scrollable content */}
        <Box sx={{ overflowY: 'auto', flex: 1, px: { xs: 2, sm: 2.5, md: 3 }, pb: { xs: 2.5, sm: 3 } }}>

          <Box sx={{ mb: { xs: 2, sm: 3 } }}>
            <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: { xs: '0.8rem', sm: '0.88rem', md: '0.95rem' }, color: '#FFFFFF', mb: { xs: 1, sm: 1.5 } }}>
              1. Operational Scope &amp; Statutory Compliance
            </Typography>
            <Typography sx={{ fontFamily: '"Open Sans", sans-serif', fontSize: { xs: '0.72rem', sm: '0.78rem', md: '0.82rem' }, lineHeight: { xs: 1.65, sm: 1.8 }, color: 'rgba(255,255,255,0.7)' }}>
              Payible is owned and operated by Coingalaxy Pty Ltd (ACN 643368496), a registered Digital Currency Provider regulated by the Australian Transaction Reports and Analysis Centre (AUSTRAC) under DCE registration number DCE100706348. This architecture is governed by strict data minimization, user sovereignty, and transparency guidelines modeled after global standards including the Australian Privacy Act, the EU GDPR, and Mexico's LFPDPPP.
            </Typography>
          </Box>

          <Box sx={{ mb: { xs: 2, sm: 3 } }}>
            <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: { xs: '0.8rem', sm: '0.88rem', md: '0.95rem' }, color: '#FFFFFF', mb: { xs: 1, sm: 1.5 } }}>
              2. Enterprise Data Custody &amp; Safeguards
            </Typography>
            <Typography sx={{ fontFamily: '"Open Sans", sans-serif', fontSize: { xs: '0.72rem', sm: '0.78rem', md: '0.82rem' }, lineHeight: { xs: 1.65, sm: 1.8 }, color: 'rgba(255,255,255,0.7)' }}>
              All tracking metadata generated on Payible is contained within an enterprise-grade, encrypted security stack. We enforce an absolute prohibition on the selling, leasing, or commercial distribution of platform user profiles, behavioral trends, or tracking identifiers to third-party data brokers, advertising clearinghouses, or marketing syndicates.
            </Typography>
          </Box>

          <Box sx={{ mb: { xs: 2, sm: 3 } }}>
            <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: { xs: '0.8rem', sm: '0.88rem', md: '0.95rem' }, color: '#FFFFFF', mb: { xs: 1, sm: 1.5 } }}>
              3. Granular User Rights &amp; Script Execution
            </Typography>
            <Typography sx={{ fontFamily: '"Open Sans", sans-serif', fontSize: { xs: '0.72rem', sm: '0.78rem', md: '0.82rem' }, lineHeight: { xs: 1.65, sm: 1.8 }, color: 'rgba(255,255,255,0.7)' }}>
              Modifying your configurations within this control panel instantly updates our production tracking script architecture at the edge. Opting out of performance or preference cookies is entirely frictionless; it will never degrade your execution routing, restrict access to your digital wallet balances, or impact your active transaction pipelines.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, fontSize: { xs: '0.8rem', sm: '0.88rem', md: '0.95rem' }, color: '#FFFFFF', mb: { xs: 1, sm: 1.5 } }}>
              4. Data Protection Enquiries
            </Typography>
            <Typography sx={{ fontFamily: '"Open Sans", sans-serif', fontSize: { xs: '0.72rem', sm: '0.78rem', md: '0.82rem' }, lineHeight: { xs: 1.65, sm: 1.8 }, color: 'rgba(255,255,255,0.7)' }}>
              Users maintain complete sovereign rights over their data footprint, including the right to request full audits or permanent erasure of stored analytical logs. For dedicated escalations or deeper inquiries regarding our privacy infrastructure, contact our Compliance and Data Protection team directly at: support@coinreserve.net
            </Typography>
          </Box>

        </Box>
      </Box>
    </Dialog>
  );
}

export default CookiePolicyPanel;
